<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header-->
    <header-component :headerTitle="headerText" />
    <!-- Dialog popup -->
    <v-row justify="center" style="margin-left: 20px;">
      <v-dialog v-model="download_dialog" persistent max-width="350px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex">
            <span>Download</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" style="float:right;" icon @click="download_dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <div>
              <v-row style="margin-left: 20px;">
                <v-col cols="6">
                  <input type="radio" id="option1" class="custom-radio" value="download_csv" v-model="selectFormatType">
                  <label class="custom-label" for="option1">CSV</label>
                </v-col>
                <v-col cols="6">
                  <input type="radio" id="option2" class="custom-radio" value="download_xls" v-model="selectFormatType">
                  <label class="custom-label" for="option2">XLS</label>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn small class="text-none" outlined color="primary" @click="download_dialog = false">Cancel</v-btn>
            <v-btn small class="text-none" color="primary" @click="downloadFile" :disabled="!selectFormatType || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- address Popup -->
    <v-row justify="center">
      <v-dialog v-model="address_popup" persistent max-width="700px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex">
            <span>Address</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="address_popup = !address_popup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Address</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.address ? item_details.address : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">City</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.city ? item_details.city : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">State</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.state ? item_details.state : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Country</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.country ? item_details.country : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Branch</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.branch ? item_details.branch : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Zone</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.zone ? item_details.zone : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Region</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.region ? item_details.region : 'N/A' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- address Popup -->
    <v-row justify="center">
      <v-dialog v-model="location_poc_popup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Location POC</span>
            <v-spacer></v-spacer>
            <v-btn variant="flat" icon @click="location_poc_popup = !location_poc_popup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Name</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.name ? item_details.name : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Mobile Number</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.mobile_no ? item_details.mobile_no : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">E-mail ID</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.email_id ? item_details.email_id : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Download popup -->
  <v-row justify="center">
  <v-dialog v-model="downloadDialog" persistent max-width="364px">
    <v-card class="v-card-100">
      <v-card-title class="d-flex">
        <span>Download</span>
        <v-spacer></v-spacer>
        <v-btn variant="solo" icon @click="downloadDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider :thickness="2" class="border-opacity-25 m-0"/>
      <v-card-text class="download-email">
        <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="12">
                <v-text-field color="primary" label="Email Id" variant="outlined" :rules="emailRules" @input="validateEmail" v-model="email_id" type="text"></v-text-field>
              </v-col>
            </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions center>
        <v-spacer></v-spacer>
        <v-btn size="large" class="text-none" variant="outlined" color="primary" @click="downloadDialog = false">Cancel</v-btn>
        <v-btn size="large" class="text-none" variant="flat" color="primary" @click="downloadFile('submit')" :disabled="!email_id || number > 0">Submit</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-row>
  <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- Confirm delere dialog -->
    <v-row justify="center" style="margin-left: 20px;">
      <v-dialog v-model="confirmationModelDelete" persistent max-width="350px">
        <v-card class="v-card-100">
          <v-card-title class="mb-5 d-flex">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="confirmationModelDelete = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-25 m-0"/>
          <v-card-text>
            <div>
              <v-row style="margin-left: 20px;">
                <span>Are You Sure You want to Delete?</span>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn small variant="outlined" class="text-none"  color="primary" @click="confirmationModelDelete = false">Cancel</v-btn>
            <v-btn small color="primary" class="text-none"  @click="deleteReqMappedLocation">Yes</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Tabs -->
    <v-card class="v-card-100 mt-6">
      <v-tabs v-model="tab_index" color="primary">
        <v-tab class="component-tab-heading" ripple @click="loadData(tab, 'tab_clicked', index)" style="text-transform: none!important;
          text-decoration: none; padding-top: 4px;" v-for="(tab, index) in tabs" :key="`${tab + index}`"> {{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <!-- search, action button and filter -->
    <v-card-title class="action-style pb-0">
      <!-- Search fields -->
      <v-row class="mx-3 mt-4 mb-1">
        <v-autocomplete v-model="select_field" :items="select_field_items" label="Select Field" color="primary" variant="outlined" style="max-width: 158px;" class="mr-4">
          <template v-slot:item="{ props }">
            <v-list-item v-bind="props" class="multiline-list-item" >
              <v-list-item-content>
                <v-list-item-title v-html="props.item"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
        <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" color="primary" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="fetchMasterLocation('search')" :disabled="!select_field"></v-text-field>
        <v-spacer></v-spacer>
      <v-actions>
        <v-btn class="mr-2 custum-button text-none" variant="flat" v-if="selected.length > 0" @click="downloadFile('selected')" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
        <v-btn class="mr-2 custum-button text-none" variant="flat" v-if="selected.length === 0" @click="openPopup" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
        <v-btn class="mr-2 custum-button text-none" variant="flat" @click="navigateToFileUpload" color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Upload</v-btn>
        <!-- <v-btn class="mr-2" @click="navigateToAddLocationMaster('add')" color="primary">Add</v-btn> -->
        <!-- <v-btn class="mr-2" @click="navigateToAddLocationMaster('edit')" :disabled="(selected.length !== 1)" color="primary">Edit</v-btn> -->
        <!-- <v-btn v-if="active_tab !== 'Master Location'" :disabled="(selected.length !== 1)" @click="deletePopConfirm" class="mr-2" color="primary">Delete</v-btn> -->
      </v-actions>
      <!-- Filter -->
      <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" v-if="active_tab === 'Location Master'" 
        readonly style="max-width: 110px; margin-bottom: 28px; min-height: 56px;">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons">
          <v-expansion-panel-title>Filter
            <template v-slot:actions>
              <v-icon color="primary">
                mdi-menu-down
              </v-icon>
            </template>
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    </v-card-title>
    <!-- tabs data -->
    <v-layout column>
      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
        <v-data-table :dense="true" :search="search" v-model="selected" show-select disable-pagination
          :hide-default-footer="true" :headers="computedHeaders" :items="table_data" :items-per-page="pageSize" return-object :loading="loading" fixed-header
          height="100%" loading-text="Loading Data... Please wait" class="elevation-1">
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in computedHeaders">
              <span v-if="header.key == 'lat_lng_updated_at'">
                <span>{{formattedDate(item.lat_lng_updated_at)  ? formattedDate(item.lat_lng_updated_at) : "-" }}</span>
              </span>  
              <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key == 'address_line1'">
                <v-tooltip location="top" text="item.address_line1" >
              <template v-slot:activator="{ props }">
                <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.address_line1)">
                  {{ (item.address_line1 ? item.address_line1.substring(0, 18) + '...' : '-') }}
                </a>
              </template>
              <span style="max-width: 700px; word-wrap: break-word;">{{ item.address_line1 }}</span>
            </v-tooltip>              
          </span>  
              <span v-else>-</span>
            </template>
            <!-- <template v-for="(header, index) in headers" v-slot:[`item.${header.value}`]="{ item }">
              <span v-if="item[header.value] !== null && item[header.value] !== ''">
                {{ item[header.value] }}
              </span>
              <span v-else>
                <span>-</span>
              </span>
          </template> -->
          <!-- <template #[`item.lat_log`]="{item}">
            <span>{{ item.lat_log ? item.lat_log : "-" }}</span>
          </template> -->
          <!-- <template #[`item.address_line1`]="{item}">
            <v-tooltip location="top" text="item.address_line1" >
              <template v-slot:activator="{ props }">
                <a v-bind="props" style="color: #1976d2;" @click="showFullText(item.address_line1)">
                  {{ item.address_line1.substring(0, 18) }}...
                </a>
              </template>
              <span style="max-width: 700px; word-wrap: break-word;">{{ item.address_line1 }}</span>
            </v-tooltip>
          </template> -->
          <!-- <template #[`item.lat_lng_updated_at`]="{item}">
            <span>{{formattedDate(item.lat_lng_updated_at)  ? formattedDate(item.lat_lng_updated_at) : "-" }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent max-width="1224px">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-col>
              <v-combobox color="primary" prepend-inner-icon="mdi-magnify" clearable multiple v-model="location_owner" :items="location_owner_items"  label="Location Owner" variant="outlined"></v-combobox>
            </v-col>
            <v-col>
              <v-combobox color="primary" prepend-inner-icon="mdi-magnify" clearable multiple v-model="type_of_loc" :items="type_of_loc_items" label="Type Of Location"  variant="outlined"></v-combobox>
            </v-col>
            <v-col>
              <v-combobox color="primary" prepend-inner-icon="mdi-magnify" clearable multiple v-model="location_type" :items="location_type_items" label="Location Type" variant="outlined"></v-combobox>          
            </v-col>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn class="text-none" variant="outlined" size="small" color="primary" @click="filteWithSubPopup = false">Cancel</v-btn>
            <v-btn class="text-none" variant="flat" size="small" color="primary" @click="fetchMasterLocation('filter')">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
import HeaderComponent from "../../../../../commoncomponents/HeaderComponent.vue"
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
export default {
  components: {
    HeaderComponent
  },
  data() {
    return {
      headerText: "Location Master",
      alert: false,
      alert_type: 'info',
      alert_message: '',
        // tabs: ["Master Location", "Forward Location Mapping", "Reverse Location Mapping"],
      tabs : ["Location Master", "Location Mapping"],
      active_tab : '',
      loading : false,
      selected:[],
      headers : [],
      table_data : [],
      search  : '',
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      search_tag:'',
      filteWithSubPopup: false,
      location_type_filt: '',
      location_type_items: [],
      city_filt: '',
      state_filt: '',
      branch_filt: '',
      zone_filt: '',
      region_filt: '',
      download_dialog: false,
      selectFormatType: '',
      location_type: null,
      address_popup: false,
      item_details: '',
      location_poc_popup: false,
      snackbar: false,
      download_message: '',
      city_filt_items: [],
      state_filt_items: [],
      branch_filt_items: [],
      zone_filt_items: [],
      region_filt_items: [],
      headerTextSub: '',
      confirmationModelDelete: false,
      tab_index: 0,
      action: '',
      active_tab_condi: '',
      number: 0,
      select_field_items:[],
      select_field:null,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      location_owner:null,
      location_owner_items:[],
      type_of_loc:null,
      type_of_loc_items:[],
      downloadDialog:false,
      email_id:'',
      email_format_rule: [
        v => (/^[\w,.]+([\.-]?[\w,.]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email_id)) || "Please enter valid Email"
      ],
      isEmailValid:true,
      emailError:'',
      organization_name:'',
    }
  },
  async created() {
    this.headerTextSub = this.$store.state.inventoryId;
    this.organization_name = this.$store.state.organization_name;
    this.action = this.$store.state.action;
    this.download_message = this.$store.state.lotIds;
    this.active_tab_condi = this.$store.state.active_tab
    if(this.active_tab_condi === 'first_tab'){
      this.tab_index = 0;
      this.loadData('Location Master');
    }else if(this.active_tab_condi === 'second_tab'){
      this.tab_index = 1;
      this.loadData('Location Mapping');
    }else{
      this.loadData('Location Master');
    }

    if (this.headerTextSub === 'success') {
      this.snackbar = true
    }

  },
  computed: {
    emailRules() {
      return [
        v => this.emailError || true
      ];
  },
     computedHeaders() {
      if (this.$isWhirlpoolClient()) {
        return this.headers.filter(header => header.value !== 'branch' && header.value !== 'item_type' && header.value !== 'category');
      } else {        
        return this.headers;
      }
    },
  },
  methods: {
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    loadData(tab, tab_action) {
      if (tab_action) {
        this.search_tag = null;
        this.select_field=null;
      }
      // this.download_message = ''
      this.loading = false;
      this.selected = []
      this.active_tab = tab
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.successPopup = false;
      this.$store.commit("setLotIds", {});
      this.$store.commit("setActiveTab", {});
      if(tab == 'Location Master'){
        this.$store.commit("setActiveTab", {
          active_tab:'first_tab'
        }); 
        this.headers = [
          { title: "Location Organization", key: "location_organization", minWidth: "230px" },
          { title: "Location ID", key: "code", minWidth: "200px" },
          { title: "Location Name", key: "name", minWidth: "200px" },
          { title: "Location Owner", key: "location_owner_name", minWidth: "200px" },
          { title: "Type Of Location", key: "type_of_location", minWidth: "200px" },
          { title: "Location Type", key: "location_type", minWidth: "200px" },
          { title: "Category", key: "category", minWidth: "200px"},
          { title: "Address", key: "address_line1", minWidth: "150px" },
          { title: "City", key: "city", minWidth: "200px" },
          { title: "State", key: "state", minWidth: "200px" },
          { title: "Country", key: "country", minWidth: "200px" },
          { title: "PIN Code", key: "pin_code", minWidth: "200px" },
          { title: "Lat/Log", key: "lat_log", minWidth: "120px" },
          { title: "Branch", key: "branch", minWidth: "200px" },
          { title: "Type Of Item", key: "item_type", minWidth: "200px" },
          { title: "Location Head", key: "location_head_name", minWidth: "200px" },
          { title: "POC Name", key: "poc_name", minWidth: "200px" },
          { title: "POC Contact Number", key: "poc_mobile", minWidth: "200px" },
          { title: "POC Email ID", key: "poc_email", minWidth: "200px" },
          { title: "Lat-Long Captured Date", key: "lat_lng_updated_at", minWidth: "250px"},
        ];
        this.select_field_items = [
          "Location Organization",
          "Location ID",
          "Location Name"];
          if (this.$isRelianceClient()) {
          const fieldsToRemove = ["category", "branch", "item_type"];
            this.headers = this.headers.filter(header => !fieldsToRemove.includes(header.key));
          }
          this.fetchMasterLocation();
      } else if (tab == 'Location Mapping'){
        this.$store.commit("setActiveTab", {
          active_tab:'second_tab'
        });
        this.headers = [
          { title: "Location ID", key: "code", minWidth: "200px" },
          { title: "Mapped User ID", key: "mapped_user_ids", minWidth: "200px" },
          { title: "Mapped Reverse Dispacth(Processing) Locations", key: "mapped_reverse_dispatch_locations", minWidth: "400px" },
          { title: "Mapped Forward Dispacth(Processing) Locations", key: "mapped_forward_dispatch_locations", minWidth: "400px" },
        ];
        this.select_field_items = [
        "Location ID",
        "Mapped User ID",
        "Mapped Reverse Dispacth(Processing) Locations",
        "Mapped Forward Dispacth(Processing) Locations"];
        this.fetchMasterLocation();
      } 
      // else if(tab == 'Reverse Location Mapping'){
      //   this.headers = [
      //   { text: "Master Location", value: "master_location" },
      //     { text: "Reverse Child Location", value: "reverse_child_location" },
      //   ];
      //   this.fetchReverseLocmapping();
      // }
    },
    fetchMasterLocation(value){
      this.loading = true;
      const params = {
        page: this.page,
        per_page: this.pageSize,   
      };
      if(value === 'search'){
        if(this.select_field === 'Location Name'){
          params.name = this.search_tag
        }else if(this.select_field === 'Location ID'){
          params.code = this.search_tag
        }else if(this.select_field === 'Location Organization'){
          params.location_organization = this.search_tag
        }else if(this.select_field === 'Mapped User ID'){
          params.mapped_user_ids = this.search_tag
        }else if(this.select_field === 'Mapped Reverse Dispacth(Processing) Locations'){
          params.mapped_reverse_dispatch_locations = this.search_tag
        }else if(this.select_field === 'Mapped Forward Dispacth(Processing) Locations'){
          params.mapped_forward_dispatch_locations = this.search_tag
        }
      }else if(value === 'filter'){
        this.select_field = null;
        this.search_tag = '';
        params.location_owner_name = Array.isArray(this.location_owner) ? this.location_owner.join(',') : this.location_owner;
        params.type_of_location = Array.isArray(this.type_of_loc) ? this.type_of_loc.join(',') : this.type_of_loc;
        params.location_type =  Array.isArray(this.location_type) ? this.location_type.join(',') : this.location_type;
      }
      this.$httpSecured
        .get(`/admin/distribution_centers`,{ params: params })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.distribution_centers.map(dc => ({
              ...dc,
              lat_log: (dc.latitude && dc.longitude) ? `${dc.latitude}, ${dc.longitude}` : '-'
            }));
            this.filteWithSubPopup = false;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.location_owner = null;
            this.type_of_loc = null;
            this.location_type = null;
            this.loading = false;
            this.fetchFilterData()
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    fetchForwardLocMapping() {
      this.loading = true;
      const params = {
        page: this.page,
        per_page: this.pageSize,
        search: this.search_tag,
        action_type: 'index',
        location_type: 'forward_location'
      };
      this.$httpSecured
        .get(`/admin/distribution_centers/master_location`, { params: params })
        .then(response => {
          if (response.data) {
            let forwardData = [];
            response.data.master_locations.forEach(masterLoc => {
              masterLoc.child_location.forEach(childLoc => {
                forwardData.push({
                  id: masterLoc.id,
                  master_location: masterLoc.master_location,
                  forward_child_location: childLoc.child_location_code
                });
              });
            });
            // this.table_data = forwardData;
            let temp_data = [];
            forwardData.forEach((item, index) => {
              let prossed_entry = {}
              if (index == 0 || item[this.headers[0].key] != forwardData[index-1][this.headers[0].key])
                prossed_entry[this.headers[0].key] = item[this.headers[0].key]
              else prossed_entry[this.headers[0].key] = ''
              prossed_entry.id = item.id
              prossed_entry.show_select = false
              prossed_entry[this.headers[1].key] = item[this.headers[1].key]
              temp_data.push(prossed_entry)
            })
            this.table_data = temp_data
            this.filteWithSubPopup = false;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    fetchReverseLocmapping() {
      this.loading = true;
      const params = {
        page: this.page,
        per_page: this.pageSize,
        search: this.search_tag,
        action_type: 'index',
        location_type: 'reverse_location'
      };
      this.$httpSecured
        .get(`/admin/distribution_centers/master_location`, { params: params })
        .then(response => {
          if (response.data) {
            let forwardData = [];
            response.data.master_locations.forEach(masterLoc => {
              masterLoc.child_location.forEach(childLoc => {
                forwardData.push({
                  id: masterLoc.id,
                  master_location: masterLoc.master_location,
                  reverse_child_location: childLoc.child_location_code
                });
              });
            });
            // this.table_data = forwardData;
            let temp_data = [];
            forwardData.forEach((item, index) => {
              let prossed_entry = {}
              if (index == 0 || item[this.headers[0].key] != forwardData[index - 1][this.headers[0].key])
                prossed_entry[this.headers[0].key] = item[this.headers[0].key]
              else prossed_entry[this.headers[0].key] = ''
              prossed_entry.id = item.id
              prossed_entry.show_select = false
              prossed_entry[this.headers[1].key] = item[this.headers[1].key]
              temp_data.push(prossed_entry)
            })
            this.table_data = temp_data
            this.filteWithSubPopup = false;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1
      // if (this.active_tab == 'Master Location') {
        this.fetchMasterLocation();
      // }
    },
    handlePageChange(value) {
      this.page = value;
      // if (this.active_tab == 'Master Location') {
        this.fetchMasterLocation();
      // }
    },
    filterListOfButtons() {
      this.filteWithSubPopup = true;
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
    },
    navigateToAddLocationMaster(condition) {
      if (condition === 'add') {
        this.$store.commit("setLotIds", {
          lotIds: '',
          action: condition,
          inventoryId: this.active_tab
        });
      } else if (condition === 'edit') {
        this.$store.commit("setLotIds", {
          lotIds: this.selected.map(loc_id => loc_id.id),
          action: condition,
          inventoryId: this.active_tab
        });
      }

      this.$router.push({ name: "addLocationMaster" });
    },
    downloadPopup() {
      this.download_dialog = true
    },
    itemDetailpopup(item) {
      this.address_popup = true
      this.item_details = item;
      this.$httpSecured
        .get(`/admin/distribution_centers/${item.id}/fetch_address`)
        .then(response => {
          if (response.data) {
            this.item_details = response.data.address
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    itemLocationPocPopup(item) {
      this.location_poc_popup = true
      this.item_details = item;
      this.$httpSecured
        .get(`/admin/distribution_centers/${item.id}/fetch_location_poc`)
        .then(response => {
          if (response.data) {
            this.item_details = response.data.location_poc
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      },
      openPopup(){
        this.downloadDialog = true;
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id)
      },
      downloadFile(value) {
        this.number++;
        const formData = new FormData();
        if(value === 'submit'){
          formData.append('email', this.email_id);
        }else{
          const ids = this.selected.map(item => item.id);
          formData.append('ids', ids);
        } 
        let url;
        if(this.active_tab === 'Location Mapping'){
          url = "/admin/distribution_centers/download_location_mapping"
        }else if(this.active_tab === 'Location Master'){
          url = "/admin/distribution_centers/download_location_master"
        }
      this.$httpSecured
        .post(url, formData)
        .then(response => {
          if (response.data) {
            if(value === 'submit'){
              this.snackbar = true;
              this.downloadDialog = false;
              this.email_id='';
              this.snackbar = {
                color: "success",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: 'Success',
                text: response.data.message,
                visible: true
              };
            }else{
              const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              this.snackbar = {
                color: "success",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: "Success",
                text: "(CSV File) Downloaded Successfully",
                visible: true
              };
            } 
              this.selected = [];
              this.number = 0;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
          this.number = 0;
        });
      },
      downloadImage(url) {
        let a = document.createElement('a');
        a.download = url
        a.href = url;
        document.body.appendChild(a);
        a.click();
        a.remove();
      },
    navigateToFileUpload() {
      if (this.active_tab === 'Location Master'){
        this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: this.active_tab,
          action: 'first_tab'
        });
      } else if (this.active_tab === 'Location Mapping') {
        this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: this.active_tab,
          action: 'second_tab'
        });
      }
      this.$router.push({ name: "LotFileuploadComm" });
    },
    addItem(item) {
      if (item.show_select) {
        this.selected.push(item)
      } else {
        this.selected = this.selected.filter(obj => obj.id !== item.id);
      }
    },
    fetchFilterData() {
      this.$httpSecured
        .get(`/admin/distribution_centers/filters_data`)
        .then(response => {
          if (response.data) {
            this.location_type_items = response.data.location_type;
            this.location_owner_items = response.data.location_owners;
            this.type_of_loc_items = response.data.type_of_locations;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    deletePopConfirm() {
      this.confirmationModelDelete = true
    },
    deleteReqMappedLocation() {
      const id = this.selected.map(loc_id => loc_id.id)
      this.$httpSecured.delete(`/admin/distribution_centers/${id}/delete_mapped_location`)
        .then(response => {
          if (response.data) {
            this.download_message = response.data
            this.confirmationModelDelete = false
            this.download_dialog = false
            this.snackbar = true
          } else {
            this.showAlert("error", "No Data Found");
          }
        }).catch(error => {
          this.showAlert("error", "Something went wrong from Network");
          this.loading = false;

        });

    },
    afterClickOK() {
      this.snackbar = false
      this.$store.commit("setLotIds", {});
      this.loadData(this.active_tab)
    },
    validateEmail() {
      const emails = this.email_id.split(',').map(email => email.trim());
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emails.length === 1 && !emailPattern.test(emails[0])) {
        this.emailError = 'Please enter a valid email';
        this.isEmailValid = false
        return;
      }else{
        this.isEmailValid = true
      }
      for (const email of emails) {
        if (!emailPattern.test(email)) {
          this.emailError = 'Please enter valid email ids separated by commas';
          this.isEmailValid = false
          return;
        }else{
          this.isEmailValid = true
        }
      }     
      this.emailError = null;
    },
    formattedDate(item) {
      if (item) {
        // Split the date and time
        const [datePart, timePart] = item.split(' - ');
        // Split the date into year, month, day
        const [year, month, day] = datePart.split('-');
        // Format the date as dd-mm-yyyy
        const formattedDate = `${day}-${month}-${year}`;
        // Return the formatted date and time
        return `${formattedDate} ${timePart}`;
      }
      return '-';
    }
  }
}
</script>
<style scoped>
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}

@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}

.v-dialog:has(.filter-dispatch) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}

.v-dialog>.v-card>:has(.v-card__title) {
  overflow-wrap: break-word !important;
}

.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, .42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}
:deep(.v-dialog__content .filter-dispatch) {
  box-shadow: none !important;
} 
.custom-radio {
  width: 20px;
  /* Adjust the size as needed */
  height: 20px;
  /* Adjust the size as needed */
}
.custom-label{
  position: absolute;
  margin-left: 10px
}
:deep(.multiline-list-item .v-list-item-title) {
  white-space: pre-wrap; /* Allows wrapping of text within the list item */
  word-break: break-word; /* Ensures words break and wrap appropriately */
  line-height: 1.2; /* Adjusts the line height for better readability */
  max-width:200px;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 316px) !important;
}
.filter_ui{
  margin-left: 18px !important;
  margin-top: 6px !important;
}
</style>